const Status = {
    UN_AUTHORIZED: 'UN_AUTHORIZED',
    VERIFICATION: 'VERIFICATION',
    AUTHORIZED: 'AUTHORIZED',
};

const CodeErrors = {
    UserNotExistError: 'UserNotExistError',
    AuthCodeNotValidError: 'AuthCodeNotValidError',
    UserSessionError: 'UserSessionError',
    AuthorizationRequiredError: 'AuthorizationRequiredError',
    RefreshTokenNotValid: 'RefreshTokenNotValid',
    ArchiveUploadingError: 'ArchiveUploadingError',
    InvalidArchiveExtensionError: 'InvalidArchiveExtensionError',
    InternalServerError: 'InternalServerError'
};

const Localizations = {
    ru: {
        id: 0,
        name: 'sber-solutions.ru'
    },
    com: {
        id: 1,
        name: 'sber-solutions.com'
    },
    kz: {
        id: 2,
        name: 'sber-solutions.kz'
    },
    az: {
        id: 2,
        name: 'sber-solutions.az'
    }
};

const LoadFormState = {
    ru_load_site: 'ru_load_site',
    ru_load_pdf: 'ru_load_pdf',
    com_load_site: 'com_load_site',
    com_load_pdf: 'com_load_pdf',
    kz_load_site: 'kz_load_site',
    kz_load_pdf: 'kz_load_pdf',
    az_load_site: 'az_load_site',
    az_load_pdf: 'az_load_pdf',
};

const StatesLoadForm = {
    chooseFile: 'chooseFile',
    loadFile: 'loadFile'
};

const SOCKET_STATUSES = {
    archive_loaded: "archive_loaded",
    archive_unpacked: "archive_unpacked",
    done: "done",
};

const STATUS_LOAD = {
    promise: 'Ожидание',
    load: 'В процессе',
    success: 'Готово',
};

const PROCESSES_LOADED_SITE = {
    archive_loaded: 'Загрузка архива',
    archive_unpacked: 'Распаковка архива',
    done: 'Обновление сайта',
};

const PROCESSES_LOADED_PDF = {
    done: 'Статус'
};

const USERS = {
    users: 'Пользователи'
};

export {
    Status,
    CodeErrors,
    Localizations,
    LoadFormState,
    StatesLoadForm,
    SOCKET_STATUSES,
    PROCESSES_LOADED_SITE,
    PROCESSES_LOADED_PDF,
    STATUS_LOAD,
    USERS,
};
